import { render, staticRenderFns } from "./PForm.vue?vue&type=template&id=4a4e1c5a&"
import script from "./PForm.vue?vue&type=script&async=true&lang=js&"
export * from "./PForm.vue?vue&type=script&async=true&lang=js&"
import style0 from "./PForm.vue?vue&type=style&index=0&id=4a4e1c5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports